import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody53.css';

import clientimg from '../images/case-study-client53.webp'
import outcome from '../images/outcome53.webp'

import sm1 from '../images/cs53so1.webp'
import sm2 from '../images/cs53so2.webp'
import sm3 from '../images/cs53so3.webp'
import sm4 from '../images/cs53so4.webp'


const Casestudybody53 = () => {

    return (
        <>
        <section className='casestudybody53-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>An adventure-hospitality platform specialised in developing and operating majorly three asset types: premium lodges, adventure parks, and training academies across multiple geographies</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client sought investor-ready financial models to support a parallel capital raise for a multi-country hospitality platform, structured through an integrated HoldCo, PropCo, and OpCo framework ahead of its flagship regional launch</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody53-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Onboarding Workshop</h4>
                          <p>Initiated a kick-off meeting to discuss the preliminary list of potential development sites as identified by the client by assessing factors such as land readiness, asset mix, cash flow potential, and roll-out priorities</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Validation of Assumptions</h4>
                          <p>Validated client-provided assumptions on seasonality, occupancy, and hotel pricing through triangulated hospitality market research against regional benchmarks</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Model Architecture</h4>
                          <p>Designed a fully integrated financial model architected across Country HoldCo, PropCo, and OpCo vehicles, with dedicated Group-level consolidation to reflect the client's multi-entity ownership structure and inter-company flows</p>
                        </div>
                      </div>
    
                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Transaction Structuring and Return Analysis</h4>
                          <p>Evaluated alternative financing and ownership structures debt, equity, and inter-company funding and their impact on OpCo, PropCo, and HoldCo IRRs, leverage efficiency, and cash flows; then assessed expected returns via vintage period, investment value, and exit value</p>
                        </div>
                      </div>


                  <div class="ai-section">

                    {/* <!-- Impact of AI --> */}
                    <div class="impact-panel">

                      <h2 class="section-heading">
                        <span class="heading-accent"></span>
                        Impact of AI
                      </h2>

                      <div class="impact-stat">
                        <span class="stat-arrow">▲</span>
                        <span class="stat-number">~20%</span>
                        <span class="stat-label">
                          Efficiency<br />
                          Increased
                        </span>
                      </div>

                      <div class="impact-stat">
                        <span class="stat-arrow">▲</span>
                        <span class="stat-number">~25%</span>
                        <span class="stat-label">
                          Accuracy<br />
                          Uplift<br />
                        </span>
                      </div>

                    </div>

                    {/* <!-- AI Integration --> */}
                    <div class="integration-panel">

                      <h2 class="section-heading">
                        <span class="heading-accent"></span>
                        AI-Integration
                      </h2>

                      <div class="integration-content">

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            TOOL DEPLOYED
                          </h3>

                          <p class="column-description">
                            Microsoft Copilot in Excel
                          </p>

                        </div>

                        
                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            TECHNOLOGY
                          </h3>

                          <p class="column-description">
                            AI-enabled drafting, complex formula construction and structural optimisation
                          </p>

                        </div>

                        
                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            WHAT WE AUTOMATED
                          </h3>

                          <p class="column-description">
                            AI supported the Control Panel driving the model, the site-level models behind each KPI (IRR, NPV, MOIC, RevPAR, ADR), and the roll-up of results from each site to the group across all geographies
                          </p>

                        </div>

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            HUMAN QC LAYER
                          </h3>

                          <p class="column-description">
                            Reviewed and validated every output against source data, benchmarking workpapers, and client requirements prior to finalisation
                          </p>

                        </div>



                        {/* <!-- Delivery Benefits --> 
                        <div class="integration-column delivery-benefits">

                          <h3 class="column-heading">
                            DELIVERY BENEFITS
                          </h3>

                          <ul class="benefits-list">
                            <li>Faster build of templates, workflows, and UI components</li>
                            <li>Quicker prototype iterations during stakeholder validation</li>
                            <li>Wider test coverage from AI-prepared test cases</li>
                            <li>Consistent code patterns and current technical documentation</li>
                            <li>Less repetitive coding, more time on business logic</li>
                          </ul>

                        </div> */}

                      </div>
                    </div>

                  </div>
                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <div>
                          <div className='sample-output1'>
                            <img src={sm2} alt=''/>
                            <img src={sm3} alt=''/>
                          </div>
                            <img src={sm4} alt=''/>
                        </div>
                      </div>
                  </div>
                  
                </div>
            </Row>

           


          </Container>
        </section>

    
        <section className='casestudybody53-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The financial models equipped the client to strategically evaluate multiple site-level opportunities and structure an optimal capital mix across three country vehicles, unlocking investor readiness ahead of the flagship regional launch</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody53
